module.exports = __webpack_public_path__ + "img/novartis-logo.b59e43b8.svg";